export { akamaiDCparser, akamaiGetDevice } from "./akamaiGetDevice";
export {
  getHTTPRoutePrefix,
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "./getApiRouteDetails";
export { getDeviceType } from "./getDeviceType";
export { getHost } from "./getHost";
export { getPartnerOnServerSide } from "./getPartnerOnServerSide";
